import React from 'react';
import { Dialog, DialogActions, DialogContent, TextField, Fab, Divider, ExpansionPanel, ExpansionPanelDetails } from '@material-ui/core'
import WsC from './providers/WsC';
import RaspunsDialog from './RaspunsDialog';
import Utils from '../../providers/Utils';
import ListaRaspunsuri from './ListaRaspunsuri';





export default class DialogSubIntrebare extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            strTip: 'radio',
            strRaspunsNume: 'Click aici pentru un nou raspuns',
            strPuncte: 0,
            objRaspunsInfo: {},
            isOpenRaspunsUpdate: false,
            isOpenRaspuns: false,
            listRaspunsuri: [],
            listTipuriIntrebari: new Utils().tipIntrebari,
            panel1:false,
        }
    }

    componentDidMount() {
        this.getWindowDimentions()
    }


    getWindowDimentions = () => {
        let windowWidth = window.innerWidth

        // console.log('windowWidth :', windowWidth);
        this.setState({
            fullScreen: windowWidth <= 800 ? true : false
        }, () => {
            // console.log('(object) :', this.state.fullScreen);
        })

    }



    getRaspunsuri = async () => {

        let ws = new WsC();


        //console.log('this.props.objIntrebareInfo.id :', this.props.objIntrebareInfo.id);
        let getRaspunsuri = await ws.customSelect('select * from chestionare_intrebari_optiuni_raspuns where isnull(inactiv,0) != 1 and id_intrebare = @p1', {
            p1: this.props.objIntrebareInfo.id
        })




        // console.warn('getRaspunsuri :', getRaspunsuri);


        if (getRaspunsuri.Succes) {

            let raspunsuriClone = [...getRaspunsuri.Content]


            // if(raspunsuriClone.length === 0){
            //    let varianteRaspuns = ['Da', 'Nu', 'Asa si asa']
            //     for(let i = 0 ; i < 3; i++){
            //         let raspuns = {id:i, 
            //                       id_intrebare:this.props.objIntrebareInfo.id,
            //                      tip:'',
            //                      label:varianteRaspuns[i],
            //                     inactiv:0,
            //                     puncte:0,
            //                     }

            //         raspunsuriClone.push(raspuns)            
            //     }

            // }

            //console.log('this.props.objIntrebareIng :', this.props.objIntrebareInfo);

            this.setState({
                listRaspunsuri: raspunsuriClone,
                strTip: this.props.objIntrebareInfo.tip
            }, () => {
                this.filterTipuri()
                this.props.getRaspunsuri()
                // this.props.getChestionar()
            })

        }

    }

    tipChange = (value) => {
        this.setState({ strTip: value,
                        panel1:false }, () => {
            this.salveaza(value)
        })
    }

    salveaza = async (t = null) => {

        // console.log('a intrnt in salveaza :');


        let ws = new WsC();

        //console.warn('t update tip intrebare  :', t);
        //console.warn('intrebare info after insert', this.props.objIntrebareInfo)
        let objToUpdate = {
            intrebare: this.props.objIntrebareInfo.intrebare,
            tip: t ? t : this.state.strTip
        }
        //console.warn('update subintrebare', objToUpdate)

        let subUpdate = await ws.update('chestionare_intrebari', objToUpdate, { id: this.props.objIntrebareInfo.id })

        // console.log('subUpdate :', subUpdate);

        if (subUpdate.Succes) {
            this.props.getRaspunsuri()
        }

    }

    insertRaspuns = async () => {

        let ws = new WsC();


        let raspuns = { label: this.state.strRaspunsNume, id_intrebare: this.props.objIntrebareInfo.id, puncte: this.state.strPuncte }
        //console.log('this.props.intrebareInfo :', this.props.objIntrebareInfo);

        let insertRaspuns = await ws.insert('chestionare_intrebari_optiuni_raspuns', raspuns)


        if (insertRaspuns.Succes) {

            let listCloneRaspuns = [...this.state.listRaspunsuri]
            raspuns.id = insertRaspuns.Content[0].id
            raspuns.inactiv = 0
            raspuns.img_src = null

            listCloneRaspuns.push(raspuns)



            this.setState({
                listRaspunsuri: listCloneRaspuns,
                strRaspunsNume: 'Click aici pentru un nou raspuns',
                strPuncte: '',
                isOpenRaspuns: false,

            }, () => {
                this.filterTipuri()
                this.props.getRaspunsuri()
            })

        }


    }
    updateRaspuns = async (r) => {


        let ws = new WsC();

        //console.log('objRaspunsInfo------ :', this.state.objRaspunsInfo)
        // console.log('r :', r);

        let updateR = await ws.update('chestionare_intrebari_optiuni_raspuns', { label: r.label, puncte: Number(this.state.strPuncte) }, { id: r.id })


        // console.log('updateR :', updateR);

        if (updateR.Succes) {
            let listRaspunsuri = [...this.state.listRaspunsuri]

            let idx = listRaspunsuri.findIndex(r => r.id === this.state.objRaspunsInfo.id)

            listRaspunsuri[idx].label = r.label

            this.setState({
                listRaspunsuri: listRaspunsuri,
                strRaspunsNume: 'Click aici pentru un nou raspuns',
                isOpenRaspunsUpdate: false
            }, () => {

                this.getRaspunsuri()
                this.props.getRaspunsuri()

            })
        }





    }

    addRaspuns = () => {
        if (this.props.objIntrebareInfo.tip.includes('img')) {
            this.insertRaspuns()
        }
        else {
            this.setState({ isOpenRaspuns: true })
        }
    }

    goToRaspuns = (r) => {
        //console.log('r :', r);

        this.setState({
            strRaspunsNume: r.label,
            strPuncte: r.puncte,
            objRaspunsInfo: r,
            isOpenRaspunsUpdate: true,

        })
    }

    deleteRaspuns = async (r) => {

        let ws = new WsC()

        let deleteRaspuns = await ws.update('chestionare_intrebari_optiuni_raspuns', { inactiv: 1 }, { id: r.id })

        if (deleteRaspuns.Succes) {
            let listCloneRaspunsuri = [...this.state.listRaspunsuri]

            let idx = listCloneRaspunsuri.findIndex(cr => cr.id === r.id)

            listCloneRaspunsuri.splice(idx, 1)

            this.setState({ listRaspunsuri: listCloneRaspunsuri }, () => {
                this.props.getRaspunsuri()
                this.filterTipuri()
            })
        }




    }

    filterTipuri = () => {

        // console.log('listRaspunsuri :', this.state.listRaspunsuri);
        if (this.state.listRaspunsuri.length > 0) {

            if (this.state.listRaspunsuri[0].tip === 'text') {
                this.setState({ listTipuriIntrebari: new Utils().tipIntrebari })
            } else {
                let tipuri = [...this.state.listTipuriIntrebari]

                let filterTipuri = tipuri.filter(t => t.id !== 'text')

                this.setState({ listTipuriIntrebari: filterTipuri })
            }


        } else {
            this.setState({ listTipuriIntrebari: new Utils().tipIntrebari })
        }
    }

    finalizeaza = () => {




        this.setState({
            strTip: 'radio',
            strRaspunsNume: 'Click aici pentru un nou raspuns',
            strPuncte: 0,
            objRaspunsInfo: {},
            isOpenRaspunsUpdate: false,
            isOpenRaspuns: false,
            listRaspunsuri: [],
            listTipuriIntrebari: new Utils().tipIntrebari
        }, () => {
            this.props.dialogClose()
            this.props.getRaspunsuri()
        })
    }

    changeRaspuns = (ev, r) => {
        //console.log('ev :', ev);
        // console.log('r :', r);

        let cloneRaspunsuri = [...this.state.listRaspunsuri]

        let idx = cloneRaspunsuri.findIndex(q => q.id === r.id)

        if (idx !== -1) {
            cloneRaspunsuri[idx].label = ev.target.value
        }

        this.setState({
            listRaspunsuri: cloneRaspunsuri,
            objRaspunsInfo: r
        })

    }


    tipuriIntrebariLabel = () => {
        if (this.state.strTip === 'radio') {
            return 'O singura varianta de raspuns'
        } else if (this.state.strTip === 'checkbox') {
            return 'Mai multe variante de raspuns'
        } else if (this.state.strTip === 'motivatie_radio') {
            return 'O singura varianta de raspuns cu motivatie'
        } else if (this.state.strTip === 'motivatie_checkbox') {
            return 'Mai multe variante de raspuns cu motivatie'
        } 
    }

    handleChangePanel = (name) => {
        this.setState({ [name]: this.state[name] ? false : true })
    }


    render() {
        return (
            <div>
                <Dialog
                    className="insertDialog"
                    style={{ padding: 10 }}
                    fullScreen={this.state.fullScreen}
                    fullWidth={true}
                    maxWidth={'md'}
                    disableEscapeKeyDown
                    open={this.props.open}
                    onClose={this.finalizeaza}>
                    <DialogActions >
                        <Fab onClick={this.finalizeaza} className="chestionare-anuleaza-button">
                            <i className='material-icons textSecondary iconFontSize'>close</i>
                        </Fab>
                    </DialogActions>


                    {/* <h2 style={{ padding: 10 }} className='chestionare-dialog-title'>{this.props.title} {this.props.objIntrebareInfo.idx}</h2> */}

                    <DialogContent style={{
                        backgroundColor: 'white',
                        borderRadius: 20,
                        position: 'relative',
                        width: '95%',
                        margin: 'auto',
                        marginBottom: 30,
                        padding: 0,
                        height: 'inherit',
                        overflowX: 'hidden',
                        overflowY: 'scroll'
                    }}>


                        <div className='stickyTitle' >


                            <h2 style={{ fontFamily: 'serif', margin: 40, display: 'flex', justifyContent: 'space-between' }}><span style={{ fontWeight: 600 }}>{this.props.title} {this.props.objIntrebareInfo.idx}</span> <i onClick={this.finalizeaza} className='material-icons iconFontSize textSecondary'>save</i></h2>

                            <Divider className='chestionare-divider' />
                        </div>

                        <div style={{ textAlign: 'center' }}>
                            <TextField label='Scrie aici subintrebare'
                                onBlur={this.props.updateIntrebare}
                                multiline
                                value={this.props.objIntrebareInfo.intrebare}
                                onChange={this.props.numeChange}
                                className='inputFocus' style={{ width: '90%' }} />
                        </div>

                        <div style={{ textAlign: 'center' }}>

                            {this.state.strTip.indexOf('motivatie') !== -1 &&
                                <TextField label='Scrie aici text motivatie'
                                    onBlur={this.props.updateIntrebare}
                                    multiline
                                    value={this.props.objIntrebareInfo.motivatie_label || ''}
                                    onChange={this.props.motivatieChange}
                                    className='inputFocus' style={{ width: '90%' }} />
                            }
                        </div>

                        {this.props.objIntrebareInfo.id !== null &&
                            <div>
                                <h3 style={{ fontFamily: 'serif', margin: 20, display: 'flex', justifyContent: 'space-between' }}><span style={{ fontWeight: 600 }}>{this.tipuriIntrebariLabel()}</span> <i onClick={() => { this.handleChangePanel('panel1') }} className='material-icons iconFontSize textSecondary'>settings</i></h3>

                                <ExpansionPanel className='chestionare-expantion' style={{ margin: 'auto', maxWidth: 350 }} expanded={this.state.panel1} onChange={() => { this.handleChangePanel('panel1') }}>


                                    {/* {this.state.isShowPreview !== true && */}

                                    <ExpansionPanelDetails style={{ display: 'block' }}>

                                        <ul style={{ textAlign: 'left', listStyleType: 'none', marginTop: 0, paddingTop: 0, paddingLeft: 0, borderLeft: '1px solid #f0f0f0' }}>
                                          


                                                <li style={{ color: this.state.strTip === 'radio' ? '#9fc59c' : '', paddingTop: 0 }} className='chestionar-settings-li' onClick={() => { this.tipChange('radio') }} >O singura varianta de raspuns</li>
                                            
                                        

                                                <li style={{ color: this.state.strTip === 'checkbox' ? '#9fc59c' : '' }} className='chestionar-settings-li' onClick={() => { this.tipChange('checkbox') }} >Mai multe variante de raspuns</li>

                                            

      

                                                <li style={{ color: this.state.strTip === 'motivatie_radio' ? '#9fc59c' : '' }} className='chestionar-settings-li' onClick={() => { this.tipChange('motivatie_radio') }} >O singura varianta de raspuns cu motivatie</li>

                                            



                                                <li style={{ color: this.state.strTip === 'motivatie_checkbox' ? '#9fc59c' : '' }} className='chestionar-settings-li' onClick={() => { this.tipChange('motivatie_checkbox') }} >Mai multe variante de raspuns cu motivatie</li>

                                            


                                           




                                        </ul>


                                    </ExpansionPanelDetails>
                                </ExpansionPanel>
                                <Divider className='chestionare-divider' />

                            </div>
                        }






                        
                        {this.props.objIntrebareInfo.id !== null && this.props.objIntrebareInfo.tip !== 'text' &&
                            <div>
                                <ListaRaspunsuri
                                    objIntrebareInfo={this.props.objIntrebareInfo}
                                    objEvaluare={{foloseste_puncte:0}}
                                    listaRaspunsuri={this.state.listRaspunsuri}
                                    focusChange={() => { this.setState({ strRaspunsNume: '' }) }}
                                    goToRaspuns={this.goToRaspuns}
                                    openRaspuns={this.addRaspuns}
                                    deleteRaspuns={this.deleteRaspuns}
                                    changeRaspuns={this.changeRaspuns}
                                    nume={this.state.strRaspunsNume}
                                    numeChange={(ev) => { this.setState({ strRaspunsNume: ev.target.value }) }}
                                    insertRaspuns={this.insertRaspuns}
                                    updateRaspuns={this.updateRaspuns}
                                />
                                <Divider className="crm-divider" />
                            </div>


                        }
                    </DialogContent>


                    {/* {this.props.objIntrebareInfo.id !== null &&
                        <Button onClick={this.finalizeaza} style={{
                            backgroundColor: 'rgb(115, 177, 24)',
                            padding: '7px 30px',
                            color: 'whitesmoke',
                            width: 'fit-content',
                            margin: 'auto',
                            marginBottom: 20
                        }} >
                            Finalizeaza
                                                                         </Button>
                    } */}
                </Dialog>


                <RaspunsDialog
                    open={this.state.isOpenRaspuns}
                    dialogClose={() => { this.setState({ isOpenRaspuns: false, strRaspunsNume: '', strPuncte: '' }) }}
                    nume={this.state.strRaspunsNume}
                    numeChange={(ev) => { this.setState({ strRaspunsNume: ev.target.value }) }}
                    puncte={this.state.strPuncte}
                    puncteChange={(ev) => { this.setState({ strPuncte: ev.target.value }) }}
                    insertUpdate={this.insertRaspuns}
                    getRaspunsuri={this.getRaspunsuri}
                    scop='adauga'
                    tipRaspuns={this.props.objIntrebareInfo.tip}
                    raspuns={this.state.objRaspunsInfo} />

                <RaspunsDialog
                    open={this.state.isOpenRaspunsUpdate}
                    dialogClose={() => { this.setState({ isOpenRaspunsUpdate: false, strRaspunsNume: '', strPuncte: '' }) }}
                    nume={this.state.strRaspunsNume}
                    numeChange={(ev) => { this.setState({ strRaspunsNume: ev.target.value }) }}
                    puncte={this.state.strPuncte}
                    puncteChange={(ev) => { this.setState({ strPuncte: ev.target.value }) }}
                    insertUpdate={this.updateRaspuns}
                    getRaspunsuri={this.getRaspunsuri}
                    tipRaspuns={this.props.objIntrebareInfo.tip}
                    raspuns={this.state.objRaspunsInfo}
                    scop='editeaza' />
            </div>
        );
    }
}